export default {
  activateText: 'Opdater umiddelbart efter slip',
  deactivateText: 'TrÃ¦k ned for at opdatere',
  finishText: 'Afslut opdatering'
};
